/**
 * Estadísticas del diario (puro): racha de días con entrada, mejor racha, total de entradas,
 * días con entrada en la semana actual y días que faltan para cerrar la semana (revisión).
 */
import { addDays, isoWeekday, type EngineSettings, type LocalDate } from '@habitos/engine';
import { weekStartOf } from './agenda';
import type { JournalRec } from './model';

export interface JournalStats {
  current: number;
  best: number;
  entries: number;
  /** Lunes…domingo (según el inicio de semana) con su fecha y si hay entrada. */
  week: { day: LocalDate; weekday: number; written: boolean; future: boolean }[];
  /** Días hasta que termine la semana y se pueda hacer la revisión semanal (1 = hoy es el último). */
  daysToReview: number;
}

export function journalStats(journal: JournalRec[], today: LocalDate, settings: EngineSettings): JournalStats {
  const live = journal.filter((j) => !j.deletedAt && (j.text.trim() || j.prompts.some((p) => p.answer.trim())));
  const days = new Set(live.map((j) => j.date));
  // La racha sigue viva si hoy aún no se escribió pero ayer sí.
  let d = days.has(today) ? today : addDays(today, -1);
  let current = 0;
  while (days.has(d)) {
    current++;
    d = addDays(d, -1);
  }
  let best = 0;
  let run = 0;
  let prev: LocalDate | null = null;
  for (const day of [...days].sort()) {
    run = prev && addDays(prev, 1) === day ? run + 1 : 1;
    best = Math.max(best, run);
    prev = day as LocalDate;
  }
  const start = weekStartOf(today, settings);
  const week = Array.from({ length: 7 }, (_, i) => {
    const day = addDays(start, i);
    return { day, weekday: isoWeekday(day), written: days.has(day), future: day > today };
  });
  return { current, best, entries: live.length, week, daysToReview: 7 - week.findIndex((w) => w.day === today) };
}
